import { teamsClient } from '@atlaskit/teams-client';
import { type TeamWithImageUrls } from '@atlaskit/teams-client/types';

import type { StoreApi, TeamAppState as TeamDataTypes } from '../../types';

export const changeTeamState = (
	currentTeamAppState: TeamDataTypes,
	teamData: TeamWithImageUrls,
): TeamDataTypes => {
	const { teamProfile } = currentTeamAppState;
	const currentTeam = teamProfile.data;

	return {
		...currentTeamAppState,
		teamProfile: {
			...teamProfile,
			data: {
				...(currentTeam as TeamWithImageUrls),
				state: teamData?.state,
				isVerified: teamData?.isVerified,
				smallAvatarImageUrl: teamData?.smallAvatarImageUrl,
				membershipSettings: teamData?.membershipSettings,
			},
		},
	};
};

export const archiveTeam =
	(teamId: string) =>
	async ({ getState, setState }: StoreApi): Promise<TeamWithImageUrls | undefined> => {
		try {
			const state = getState();
			const response = await teamsClient.archiveTeam(teamId);

			if (state.teamProfile.teamId !== teamId) {
				return;
			}
			const nextState = changeTeamState(state, response);
			setState(nextState);
			return response;
		} catch (error) {
			throw Error('Unable to Archive the team');
		}
	};

export const unarchiveTeam =
	(teamId: string) =>
	async ({ getState, setState }: StoreApi): Promise<TeamWithImageUrls | undefined> => {
		try {
			const state = getState();
			const response = await teamsClient.unarchiveTeam(teamId);

			if (state.teamProfile.teamId !== teamId) {
				return;
			}
			const nextState = changeTeamState(state, response);
			setState(nextState);
			return response;
		} catch (error) {
			throw Error('Unable to Unarchive the team');
		}
	};
